@if (error) {
  <div class="alert alert-warning alert-dismissible fade show" role="alert">
    <strong>Authentication problems!</strong> {{ errorMessage }}
    <button type="button" (click)="vanishError()" class="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
}

<div class="pt-5">
  <div class="row">
    <div class="col-md-6 mx-auto">
      <span class="anchor" id="formLogin"></span>

      <div class="card rounded-0">
        <div class="card-header">
          <h3 class="mb-0">Login</h3>
        </div>

        <div class="card-body">
          <form class="form" [formGroup]="loginForm" (ngSubmit)="loginUser()">

            <div class="form-group">
              <label for="inputUsername">Username</label>
              <input type="text" name="username" formControlName="username" class="form-control" id="inputUsername"
                aria-describedby="usernameHelp" placeholder="Enter username">
              @if (submitted && loginForm.controls.username.errors) {
                <div class="error">
                  @if (loginForm.controls.username.errors.required) {
                    <small class="form-text text-warning">Your username is
                      required!
                    </small>
                  }
                </div>
              }
            </div>

            <div class="form-group">
              <label for="password">Password</label>
              <input type="password" name="password" formControlName="password" class="form-control" id="password"
                placeholder="Password">
              @if (submitted && loginForm.controls.password.errors) {
                <div class="error">
                  @if (loginForm.controls.password.errors.required) {
                    <small class="form-text text-warning">Your password
                      is
                      required!
                    </small>
                  }
                  @if (loginForm.controls.password.errors.minlength) {
                    <small class="form-text text-warning">Your password
                      must be at least 8 characters long!
                    </small>
                  }
                </div>
              }
            </div>

            <button type="button" (click)="loginUser()" class="btn btn-success float-right">Login</button>

          </form>
        </div>

      </div>

    </div>
  </div>
</div>
